const styles = {
  table: {
    width: '75vw',
  },
  tbody: {
  },
  tHead: {
  },
  tr: {
    // border: "1px solid",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: '#fff',
  },
  th: {
    flex:1,
    display: "flex",
    height:"5rem",
    // width: "100%",
    alignItems: "center",

  },
  th_sorted: {
    flex:1,

    display: "flex",
    height:"5rem",
    alignItems: "center",
    cursor: "pointer",

  },
  td: {
    flex:1,
    display : "flex",
    alignItems:"center",
  },
  row: {
    display: "flex",
  },
  colName: {
  },
  colNameHover: {
    textDecoration: "underline",
  },
  sortIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inputContainer: {
    border: "1px solid",
  },
  input: {
    width: "100%",
    border: "1px solid",
  },
  dropDownSortIconUp: {
    height: '2rem',
    verticalAlign: 'middle',
    transform: "rotate(180deg)"
  },
  dropDownSortIconDown: {
    height: '2rem',
    verticalAlign: 'middle',
  },
  avatar: {
    height: '40px',
    width: '40px',
    borderRadius: '50%',
  },
};
export default styles;
